import * as React from 'react';

import { EEmployment } from '../../../repositories/vacancies/entities/schemas/VacancySchema';
import { ButtonGroup } from '../../button_group';

interface IEmploymentField {
  className: string;
  value: string;
  change(value: EEmployment): void;
}

const EmploymentField = (props: IEmploymentField) => (
  <div className={props.className}>
    <ButtonGroup
      value={props.value}
      onClick={props.change}
      options={[
        { value: EEmployment.Full, label: 'Полная' },
        { value: EEmployment.Part, label: 'Частичная' },
        { value: EEmployment.Piece, label: 'Сдельная оплата' },
      ]}
    />
  </div>
);

export { EmploymentField };
